import { green, red, yellow, blue, purple, grey, orange } from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "../../GenericHomePage/GenericHomePage";
import FolderCopyRoundedIcon from '@mui/icons-material/FolderCopyRounded';
import CreateNewFolderRoundedIcon from '@mui/icons-material/CreateNewFolderRounded';import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CancelPresentationRoundedIcon from '@mui/icons-material/CancelPresentationRounded';
import FolderDeleteRoundedIcon from '@mui/icons-material/FolderDeleteRounded';
import DriveFileMoveRoundedIcon from '@mui/icons-material/DriveFileMoveRounded';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import MoreTimeIcon from '@mui/icons-material/MoreTime';

const RegulatoryMemberHome = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  let sectionsBox = [
    // Active requests section
    {
      textBeside: "New Exit Request",
      icon: CreateNewFolderRoundedIcon,
      iconColor: blue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: blue[100],
      size: 3,
      onClick: () => navigate(DefaultRoutes.createIngredientExit),
    },
    {
      textBeside: "My Exit Requests",
      icon: FolderSpecialIcon,
      iconColor: purple[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: purple[100],
      size: 3,
      onClick: () => navigate(DefaultRoutes.myActiveReqs),
    },
    {
      textBeside: "My Regulatory Exemptions",
      icon: ReceiptLongIcon,
      iconColor: orange[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: orange[100],
      onClick: () => navigate(DefaultRoutes.regulatoryExemptions),
    },
    {
      textBeside: "Regulatory Ingredients Hub",
      icon: FolderCopyRoundedIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[100],
      size: 3,
      onClick: () => navigate(DefaultRoutes.activeReqs),
    },
    // Canceled requests section
    {
      textBeside: "My Canceled Requests",
      icon: DeleteForeverIcon,
      iconColor: red[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: red[100],
      size: 3,
      onClick: () => navigate(DefaultRoutes.myCanceledReqs),
    },
    {
      textBeside: "All Canceled Requests",
      icon: FolderDeleteRoundedIcon,
      iconColor: grey[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: grey[100],
      size: 3,
      onClick: () => navigate(DefaultRoutes.canceledReqs),
    },
    {
      textBeside: "Delegation Requests",
      icon: DriveFileMoveRoundedIcon,
      iconColor: grey[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: grey[100],
      size: 3,
      onClick: () => navigate(DefaultRoutes.regDelegationRequests),
    },
    {
      textBeside: "Extension Requests",
      icon: MoreTimeIcon,
      iconColor: purple[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: purple[100],
      size: 3,
      onClick: () => navigate(DefaultRoutes.regExtensionRequests),
    }
  ];
  return <GenericHomePage sectionsBox={sectionsBox} />;
};
export default RegulatoryMemberHome;
